// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"0a2b9286","453":"b4ebc401"}[chunkId] + ".chunk.js";
};